import mutations from './mutations'
import * as actions from './actions'

const state = {
  token: '',
  username: '',
  nickName: '', // 用户昵称
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
